import * as actionTypes from '../actions/actionTypes';
import * as constants from '../../constants';

import { updateState } from '../../lib/StateHelper';

const initialState = {
    adminGroup: null,
    adminGroups: null,
    adminGroupsFranchiseId: null,
    isNew: false,
    lastState: null,
    lastScope: null
};

const adminGroupReducer = (state = initialState, action) => {
    switch(action.type) {
        case actionTypes.ADMINGROUP_START: {
            return updateState(state, { ...action.data, lastState: constants.STATE_PROCESSING });
        }
        case actionTypes.ADMINGROUP_SUCCESS: {
            return updateState(state, { ...action.data, lastState: constants.STATE_SUCCESS });
        }
        case actionTypes.ADMINGROUP_FAIL: {
            return updateState(state, { lastState: constants.STATE_FAIL });
        }
        default: {
            return state;
        }
    }
};

export default adminGroupReducer;
